import * as z from 'zod';
import { naicsCodeId } from '../../../opaque.mjs';
import { safeNumberSchema } from '../../../utils.mjs';
import { Underwriting } from '../../quote/contract/contract-surety-quote.types.mixins.mjs';

var Data;
(function (Data) {
    Data.projectSchema = Underwriting.Project.schema.extend({
        input: Underwriting.Project.schema.shape.input.extend({
            description: z.string(),
            monthsToComplete: safeNumberSchema.min(1),
            contractWarrantyMonths: safeNumberSchema.nonnegative(),
            scopeOfWork: z.array(naicsCodeId),
        }),
    });
    Data.baseSchema = z.object({
        suretyType: z.literal("contract"),
        closedNote: z.string().nullish(),
        project: Data.projectSchema,
    });
})(Data || (Data = {}));

export { Data };
